import React from "react";
import { string, object } from "prop-types";
import "./section-heading.m.css";

export const SectionHeading = ({ children, style }) => {
  return (
    <div styleName="section-heading" style={style}>
      {children}
    </div>
  );
};

SectionHeading.propTypes = {
  children: string.isRequired,
  style: object,
};